(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cta-buttons"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function(){
    $("#cta_buttons").owlCarousel({
        itemsCustom : [
          [0, 1],
          [450, 1],
          [600, 2],
          [700, 2],
          [1000, 3],
          [1200, 3],
          [1400, 3],
          [1600, 3]
        ],
        navigation : false,
        pagination: false,
        touchDrag: false,
        mouseDrag: false,
        autoPlay: 4000
    });
});

  } catch(e) { console.error(e); }
})();
})();
